import { type ProductData } from "~/models/ProductData";
import { resolveUrl } from "~/utils/url/urlResolver";
import { augmentPDPUrlWithRestriction } from "./utils/augmentPDPUrlWithRestriction";
import { usePackageRestrictionContext } from "./PackageRestrictionContext";

export const useProductDetailsUrl = (productData: Pick<ProductData, "url" | "sapMaterialNumber">) => {
  const restrictedCode = usePackageRestrictionContext();

  const url = resolveUrl(productData.url);

  if (url && restrictedCode) {
    return augmentPDPUrlWithRestriction(url, productData.sapMaterialNumber + restrictedCode);
  }
  return url;
};
